import {
	CLASSIC_BACKLOG,
	COMPANY_MANAGED_BACKLOG,
} from '@jira/platform__observability-capabilities/src/constants.tsx';

export const classicBacklogCapability: 'COMPANY_MANAGED_BACKLOG' | 'CLASSIC_BACKLOG' = !__SERVER__
	? COMPANY_MANAGED_BACKLOG
	: CLASSIC_BACKLOG;
